exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___2adUE {\n  display: flex;\n}\n.containerStyling____clWa {\n  padding: 20px 100px 20px 20px;\n  border-radius: 4px;\n}\n.container--PREMIUM___64nmI {\n  background-color: #e8f3ef;\n}\n.container--BASIC___37Ueo {\n  background-color: #fffbe8;\n}\n.icon--PREMIUM___1chvR {\n  fill: #15845d;\n}\n.copy___3JlQY {\n  display: flex;\n  flex-direction: column;\n  margin-left: 12px;\n}\n.HED___12p2T {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n.DEK___2L_cV {\n  font-size: 14px;\n  padding-bottom: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___2adUE",
	"containerStyling": "containerStyling____clWa",
	"container--PREMIUM": "container--PREMIUM___64nmI",
	"container--BASIC": "container--BASIC___37Ueo",
	"icon--PREMIUM": "icon--PREMIUM___1chvR",
	"copy": "copy___3JlQY",
	"HED": "HED___12p2T",
	"DEK": "DEK___2L_cV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/ZoomPlanStatusModule/ZoomPlanStatusModule.module.less
// module id = 2408
// module chunks = 70